import { createContext } from "react";

export const DSPDisplayModeContext = createContext(null);
